import React from "react";
import { Badge, Breadcrumbs, Button, PageHeader } from "@opendate-app/setlist";

import { useCustomCampaignShowContext } from "./CustomCampaignShowContainer";
import { listHref } from "../shared/listUrlState";

const STATES = {
  active: { label: "Active", color: "success", action: "Pause Automation" },
  paused: { label: "Paused", color: "warning", action: "Resume Automation" },
};

const DRAFT = { label: "Draft", color: "gray", action: "Start Automation" };

const headerStyle = {
  padding: "4px 16px 12px",
};

const titleStyle = {
  display: "inline-flex",
  alignItems: "center",
  gap: 10,
};

const CustomCampaignHeader = ({ checkForActiveExecutionsForPause, updateCampaignState }) => {
  const {
    team,
    customCampaign,
  } = useCustomCampaignShowContext();

  const state = STATES[customCampaign.state] || DRAFT;

  const toggleCampaignState = () => {
    if (customCampaign.state === "active") {
      checkForActiveExecutionsForPause();
    } else {
      updateCampaignState("active");
    }
  };

  const buttonDisabled = !customCampaign.trigger_finalized || (
    customCampaign.state !== "active" && customCampaign.workflow_nodes.some(node => Object.keys(node.workflow_errors).length > 0)
  );

  return (
    <div style={headerStyle}>
      <PageHeader
        divider={false}
        breadcrumbs={(
          <Breadcrumbs
            items={[
              { label: "Automations", href: listHref(`/teams/${team.id}/campaigns`) },
              { label: customCampaign.name },
            ]}
          />
        )}
        title={(
          <span style={titleStyle}>
            {customCampaign.name}
            <Badge size="sm" color={state.color} dot>{state.label}</Badge>
          </span>
        )}
        actions={(
          <Button variant="primary" disabled={buttonDisabled} onClick={toggleCampaignState}>
            {state.action}
          </Button>
        )}
      />
    </div>
  );
};

export default CustomCampaignHeader;
